const ADD_LOG = 'dofe-fo/activityLogs/ADD_LOG'
const ADD_LOG_SUCCESS = 'dofe-fo/activityLogs/ADD_LOG_SUCCESS'
const ADD_LOG_FAIL = 'dofe-fo/activityLogs/ADD_LOG_FAIL'

const ADD_LOGS = 'dofe-fo/activityLogs/ADD_LOGS'
const ADD_LOGS_SUCCESS = 'dofe-fo/activityLogs/ADD_LOGS_SUCCESS'
const ADD_LOGS_FAIL = 'dofe-fo/activityLogs/ADD_LOGS_FAIL'

const EDIT_LOG = 'dofe-fo/activityLogs/EDIT_LOG'
const EDIT_LOG_SUCCESS = 'dofe-fo/activityLogs/EDIT_LOG_SUCCESS'
const EDIT_LOG_FAIL = 'dofe-fo/activityLogs/EDIT_LOG_FAIL'

const DELETE_LOG = 'dofe-fo/activityLogs/DELETE_LOG'
const DELETE_LOG_SUCCESS = 'dofe-fo/activityLogs/DELETE_LOG_SUCCESS'
const DELETE_LOG_FAIL = 'dofe-fo/activityLogs/DELETE_LOG_FAIL'

const DELETE_LOG_FILE = 'dofe-fo/activityLogs/DELETE_LOG_FILE'
const DELETE_LOG_FILE_SUCCESS = 'dofe-fo/activityLogs/DELETE_LOG_FILE_SUCCESS'
const DELETE_LOG_FILE_FAIL = 'dofe-fo/activityLogs/DELETE_LOG_FILE_FAIL'

const initialState = {
  logs: {
    loaded: false,
    data: null
  },
}

export default function activityLogs(state = initialState, action = {}) {
  switch (action.type) {
    case ADD_LOG:
      return {
        ...state,
        logs: {
          ...state.logs,
          loading: true,
        }
      }

    case ADD_LOG_SUCCESS:
      return {
        ...state,
        logs: {
          ...state.logs,
          loading: false,
          loaded: true,
          error: null,
          // data: action.result
        }
      }

    case ADD_LOG_FAIL:
      return {
        ...state,
        logs: {
          ...state.logs,
          loading: false,
          loaded: false,
          error: action.error
        }
      }

    case EDIT_LOG:
      return {
        ...state,
        logs: {
          ...state.logs,
          loading: true,
        }
      }

    case EDIT_LOG_SUCCESS:
      return {
        ...state,
        logs: {
          ...state.logs,
          loading: false,
          loaded: true,
          error: null,
          // data: action.result
        }
      }

    case EDIT_LOG_FAIL:
      return {
        ...state,
        logs: {
          ...state.logs,
          loading: false,
          loaded: false,
          error: action.error
        }
      }

    case DELETE_LOG:
      return {
        ...state,
        logs: {
          ...state.logs,
          loading: true,
        }
      }

    case DELETE_LOG_SUCCESS:
      return {
        ...state,
        logs: {
          ...state.logs,
          loading: false,
          loaded: true,
          error: null,
          // data: action.result
        }
      }

    case DELETE_LOG_FAIL:
      return {
        ...state,
        logs: {
          ...state.logs,
          loading: false,
          loaded: false,
          error: action.error
        }
      }

    case DELETE_LOG_FILE:
      return {
        ...state,
        logs: {
          ...state.logs,
          loading: true,
        }
      }

    case DELETE_LOG_FILE_SUCCESS:
      return {
        ...state,
        logs: {
          ...state.logs,
          loading: false,
          loaded: true,
          error: null,
          // data: action.result
        }
      }

    case DELETE_LOG_FILE_FAIL:
      return {
        ...state,
        logs: {
          ...state.logs,
          loading: false,
          loaded: false,
          error: action.error
        }
      }

    default:
      return state
  }
}

export function addLog(data) {
  return {
    types: [ADD_LOG, ADD_LOG_SUCCESS, ADD_LOG_FAIL],
    promise: client => client.post('api/activity-logs', { data })
  }
}

export function addLogs(data) {
  return {
    types: [ADD_LOGS, ADD_LOGS_SUCCESS, ADD_LOGS_FAIL],
    promise: client => client.post('api/activity-logs/bulk', { data })
  }
}

export function editLog(id, data) {
  return {
    types: [EDIT_LOG, EDIT_LOG_SUCCESS, EDIT_LOG_FAIL],
    promise: client => client.post(`api/activity-logs/${id}/edit`, { data })
  }
}

export function deleteLog(id) {
  return {
    types: [DELETE_LOG, DELETE_LOG_SUCCESS, DELETE_LOG_FAIL],
    promise: client => client.post(`api/activity-logs/${id}/delete`)
  }
}

export function addLogFile(activityId, data) {
  return {
    types: [ADD_LOG, ADD_LOG_SUCCESS, ADD_LOG_FAIL],
    promise: client => client.post(`api/activity-logs/${activityId}/activity-log-files`, { data })
  }
}

export function deleteLogFile(fileId) {
  return {
    types: [DELETE_LOG_FILE, DELETE_LOG_FILE_SUCCESS, DELETE_LOG_FILE_FAIL],
    promise: client => client.del(`api/activity-log-files/${fileId}`)
  }
}

